(() => {
  const cleanupEmptyWrapper = (element) => {
    const wrapper = element?.parentElement;
    element?.remove();
    if (wrapper && wrapper.children.length === 0 && wrapper.textContent.trim() === '') wrapper.remove();
  };

  const selectedVariant = (productInfo) => {
    const script = productInfo.querySelector('variant-selects [data-selected-variant]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Odd Enough Books: unable to read selected variant.', error);
      return null;
    }
  };

  const productContext = (productInfo) => {
    const script = productInfo.querySelector('[data-oeb-product-context]');
    if (!script) return { productType: '', vendor: '' };
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      console.warn('Odd Enough Books: unable to read product context.', error);
      return { productType: '', vendor: '' };
    }
  };

  const updateFormatNote = (productInfo) => {
    const variantSelects = productInfo.querySelector('variant-selects');
    const purchaseForm = productInfo.querySelector('product-form.product-form');
    if (!variantSelects || !purchaseForm) return;

    const variant = selectedVariant(productInfo);
    if (!variant) return;

    const context = productContext(productInfo);
    const productType = String(context.productType || '').toLowerCase();
    const vendor = String(context.vendor || '').toLowerCase();
    const optionText = Array.from(variantSelects.querySelectorAll('input:checked, option:checked'))
      .map((option) => option.value || option.textContent)
      .join(' ')
      .toLowerCase();

    const isService = productType === 'astrology service' || productType === 'service';
    const isDigital = !isService && (
      variant.requires_shipping === false ||
      /pdf|digital|download|ebook|e-book/.test(optionText) ||
      productType === 'digital edition' ||
      productType === 'download'
    );
    const isHpp = productType === 'holographic pagan press edition' || vendor === 'holographic pagan press';
    const isOriginal = productType === 'rare & original book' || vendor === 'odd enough books';
    const formatKey = isService ? 'service' : isDigital ? 'digital' : isHpp ? 'hpp-physical' : isOriginal ? 'original-physical' : 'physical';
    let note = productInfo.querySelector('.oeb-format-note');

    if (!note) {
      note = document.createElement('div');
      note.className = 'oeb-format-note';
      note.setAttribute('role', 'note');
      purchaseForm.before(note);
    }

    if (note.dataset.format === formatKey) return;
    note.dataset.format = formatKey;

    if (isService) {
      note.innerHTML = '<span class="oeb-format-note__label">Personalized astrology service</span><span class="oeb-format-note__detail">No physical item will be shipped. Instructions, required information, and delivery or scheduling details are provided after purchase.</span>';
    } else if (isDigital) {
      note.innerHTML = '<span class="oeb-format-note__label">Digital PDF</span><span class="oeb-format-note__detail">No physical item will be shipped. This edition is delivered electronically after purchase.</span>';
    } else if (isHpp) {
      note.innerHTML = '<span class="oeb-format-note__label">Handmade Holographic Pagan Press edition</span><span class="oeb-format-note__detail">In-stock copies ship first; additional copies may be prepared to order. Shipping is calculated during checkout.</span>';
    } else if (isOriginal) {
      note.innerHTML = '<span class="oeb-format-note__label">Original physical book</span><span class="oeb-format-note__detail">Original and vintage copies are limited to the quantity shown. Shipping is calculated during checkout.</span>';
    } else {
      note.innerHTML = '<span class="oeb-format-note__label">Physical edition</span><span class="oeb-format-note__detail">A physical item will be shipped. Shipping is calculated during checkout.</span>';
    }
  };

  const cleanProductMarkup = (root = document) => {
    root.querySelectorAll?.('.product__title > a.product__title').forEach((duplicateTitle) => duplicateTitle.remove());
    root.querySelectorAll?.('form.installment').forEach(cleanupEmptyWrapper);
    root.querySelectorAll?.('pickup-availability').forEach((pickup) => pickup.remove());

    root.querySelectorAll?.('label .label-unavailable').forEach((message) => {
      const label = message.closest('label');
      const input = label?.htmlFor ? document.getElementById(label.htmlFor) : null;
      if (input && !input.disabled && !input.classList.contains('disabled')) message.remove();
    });

    root.querySelectorAll?.('product-info').forEach(updateFormatNote);
  };

  const start = () => {
    cleanProductMarkup(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType === Node.ELEMENT_NODE) cleanProductMarkup(node);
        }
      }
      document.querySelectorAll('product-info').forEach(updateFormatNote);
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('change', () => requestAnimationFrame(() => cleanProductMarkup(document)));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();